import React, { useState } from 'react';
import { SearchOutlined, HomeOutlined, UserOutlined } from "@ant-design/icons";
import { Breadcrumb, Form, Input, Select, InputNumber, Button, Table, Tag } from "antd";
import type { TableColumnsType, TableProps } from "antd";
import withInquiryItemsLogic, { WithInquiryItemsLogicProps } from '../../components/hoc_inquiry_items';
import "./InquiryItems.css";

export interface DataType {
	key: React.Key;
	id?: number;
	item_code: string;
	item_name: string;
	brand: string;
	item_class: string;
	model: string;
	warehouse_group: string;
	location_code_rack: string;
	sales_price: number;
	qty: number;
	id_substitution?: number | null;
	substitution?: string;
	local?: string;
	children?: DataType[];
	formatted_sales_price?: string;
}

interface InquiryItemsProps extends WithInquiryItemsLogicProps {
}

const InquiryItemsUI: React.FC<InquiryItemsProps> = ({
	loading,
	handleButtonClick,
	handleRowDoubleClick,
	onChange,
	onChange1,
	onChange2,
	selectedRowKeys,
	handleRowSelectionChange,
	modelOptions,
	brandOptions,
	itemClassOptions,
	warehouseGroupOptions,
	locationCodeOptions,
	itemCodeSearch,
	handleItemCodeSearchChange,
	searchResults,
	itemNameSearch,
	handleItemNameSearchChange,
	pagination,
	handleTableChange

}) => {
	const [form] = Form.useForm();
	const columns: TableColumnsType<DataType> = [
		{
			title: "Item Code",
			dataIndex: "item_code",
			key: "item_code",
			minWidth: 300,
			sorter: true,
			onCell: () => ({
				style: {
					whiteSpace: 'nowrap',
				},
			}),
		},
		{
			title: "Item Name",
			dataIndex: "item_name",
			key: "item_name",
			sorter: true,
			onCell: () => ({
				style: {
					whiteSpace: 'nowrap',
				},
			}),
			render: (text: string, record: DataType) => {
				let color = '';
				let tagText = '';
				let displayTag = '';

				if (record.id_substitution !== null && record.id_substitution !== undefined) {
					displayTag = 'main';
				} else if (record.substitution === '1') {
					displayTag = 'substitution';
				} else if (record.local === '1') {
					displayTag = 'local';
				}


				switch (displayTag) {
					case 'main':
						color = 'blue';
						tagText = 'Main';
						break;
					case 'local':
						color = 'green';
						tagText = 'Local';
						break;
					case 'substitution':
						color = 'orange';
						tagText = 'Substitution';
						break;
					default:

						return text;
				}

				return (
					<>
						{text} {' '}
						<Tag color={color}>{tagText}</Tag>
					</>
				);
			},
		},
		{
			title: "Brand",
			dataIndex: "brand",
			key: "brand",
			sorter: true,
			render: (text: string) => {
				const option = brandOptions?.find(opt => opt.value === text);
				return option ? option.label : text;
			},
		},
		{
			title: "Item Class",
			dataIndex: "item_class",
			key: "item_class",
			sorter: true,
			render: (text: string) => {
				const option = itemClassOptions?.find(opt => opt.value === text);
				return option ? option.label : text;
			},
		},
		{
			title: "Model",
			dataIndex: "model",
			key: "model",
			onCell: () => ({
				style: {
					whiteSpace: 'nowrap',
				},
			}),
			render: (text: string) => {
				const option = modelOptions?.find(opt => opt.value === text);
				return option ? option.label : text;
			},
		},
		{
			title: "Warehouse",
			dataIndex: "warehouse_group",
			key: "warehouse_group",
			sorter: true,
			render: (text: string) => {
				const option = warehouseGroupOptions?.find(opt => opt.value === text);
				return option ? option.label : text;
			},
		},
		{
			title: "Location Code",
			dataIndex: "location_code_rack",
			key: "location_code_rack",
			sorter: true,
		},
		{
			title: "Price",
			dataIndex: "sales_price",
			key: "sales_price",
			sorter: true,
			render: (text: any, record: DataType) => record.formatted_sales_price,
		},
		{
			title: "Available Qty",
			dataIndex: "qty",
			key: "qty",
			sorter: true,
			render: (qty) => qty?.toLocaleString('id-ID'),
		},
	];

	const transformStyle = {
		transform: "scale(0.80)",
		transformOrigin: "top left",
		width: "125%",
	};

	const rowSelection: TableProps<DataType>["rowSelection"] = {
		selectedRowKeys,
		onChange: handleRowSelectionChange,
	};
	return (

		<div id="iau9" style={transformStyle}>
			{ }
			<div className="gjs-grid-row" id="ivchq">
				<div className="gjs-grid-column" id="i1ld9">
					<Breadcrumb
						items={[
							{
								title: <HomeOutlined />,
							},
							{
								title: "Inquiry Items",
							},
						]}
					/>
				</div>
			</div>
			<Form
				form={form}
				layout="horizontal"
				className="custom-info-purchase-request"
			>
				<div className="gjs-grid-row" id="iqnkj">
					<div className="gjs-grid-column" id="i8b0f">
						<div style={{ maxWidth: 500 }}>
							<div style={{ maxWidth: 500 }} className="ant-form ant-form-horizontal custom-info-purchase-request">
								<Form.Item
									label="Brand"
									name="brand"
									labelCol={{ style: { width: '200px', textAlign: "left" } }}
									wrapperCol={{ style: { width: '290px' } }}
									style={{
										marginBottom: "5px",
									}}
								>
									<Select
										showSearch
										allowClear 
										placeholder="Select Brand"
										optionFilterProp="label"
										onChange={onChange}
										options={brandOptions}
										style={{ width: "100%" }}
										getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
									/>
								</Form.Item>
								<Form.Item
									label="Model"
									name="model"
									labelCol={{ style: { width: '200px', textAlign: "left" } }}
									wrapperCol={{ style: { width: '290px' } }}
									style={{
										marginBottom: "5px",
									}}
								>
									<Select
										showSearch
										allowClear 
										placeholder="Select Model"
										optionFilterProp="label"
										onChange={onChange}
										style={{ width: "100%" }}
										options={modelOptions}
										getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
									/>
								</Form.Item>
								<Form.Item
									label="Item Code"
									name="item_code"
									labelCol={{ style: { width: '200px', textAlign: "left" } }}
									wrapperCol={{ style: { width: '290px' } }}
									style={{
										marginBottom: "5px",
									}}
								>
									<Input allowClear placeholder="Input Item Code to Search" />
								</Form.Item>
								<Form.Item
									label="Item Name"
									name="item_name"
									labelCol={{ style: { width: '200px', textAlign: "left" } }}
									wrapperCol={{ style: { width: '290px' } }}
									style={{
										marginBottom: "5px",
									}}
								>
									<Input allowClear  placeholder="Input Item Name to Search" />
								</Form.Item>
								<Form.Item
									label="Item Class"
									name="item_class"
									labelCol={{ style: { width: '200px', textAlign: "left" } }}
									wrapperCol={{ style: { width: '290px' } }}
									style={{
										marginBottom: "5px",
									}}
								>
									<Select
										showSearch
										allowClear 
										placeholder="Select Item Class"
										optionFilterProp="label"
										onChange={onChange}
										options={itemClassOptions}
										style={{ width: "100%" }}
										getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
									/>
								</Form.Item>
							</div>
						</div>
					</div>
					<div className="gjs-grid-column" id="in9tu">
						<div style={{ maxWidth: 500 }}>
							<div style={{ maxWidth: 500 }} className="ant-form ant-form-horizontal custom-info-purchase-request">
								<Form.Item
									label="Available Quantity"
									labelCol={{ style: { width: '150px', textAlign: "left" } }}
									wrapperCol={{ style: { width: '290px' } }}
									style={{
										marginBottom: "5px",
									}}
								>
									<div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
										<Form.Item name="qty_from" noStyle>
											<InputNumber<number>
												formatter={(value) =>
													`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")
												}
												parser={(value) =>
													value?.replace(/Rp\s?|\./g, "") as unknown as number
												}
												style={{ width: "100%" }}
											/>
										</Form.Item>
										<label>To</label>
										<Form.Item name="qty_to" noStyle>
											<InputNumber<number>
												formatter={(value) =>
													`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")
												}
												parser={(value) =>
													value?.replace(/Rp\s?|\./g, "") as unknown as number
												}
												style={{ width: "100%" }}
											/>
										</Form.Item>
									</div>
								</Form.Item>
								<Form.Item
									label="Sales Price"
									labelCol={{ style: { width: '150px', textAlign: "left" } }}
									wrapperCol={{ style: { width: '290px' } }}
									style={{
										marginBottom: "5px",
									}}
								>
									<div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
										<Form.Item name="price_from" noStyle>
											<InputNumber<number>
												formatter={(value) =>
													`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")
												}
												parser={(value) =>
													value?.replace(/Rp\s?|\./g, "") as unknown as number
												}
												style={{ width: "100%" }}
											/>
										</Form.Item>
										<label>To</label>
										<Form.Item name="price_to" noStyle>
											<InputNumber<number>
												formatter={(value) =>
													`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")
												}
												parser={(value) =>
													value?.replace(/Rp\s?|\./g, "") as unknown as number
												}
												style={{ width: "100%" }}
											/>
										</Form.Item>
									</div>
								</Form.Item>
								<Form.Item
									label="Warehouse"
									name="warehouse_group"
									labelCol={{ style: { width: '150px', textAlign: "left" } }}
									wrapperCol={{ style: { width: '290px' } }}
									style={{
										marginBottom: "5px",
									}}
								>
									<Select
										showSearch
										allowClear
										placeholder="Select Warehouse"
										optionFilterProp="label"
										onChange={onChange}
										options={warehouseGroupOptions}
										style={{ width: "100%" }}
										getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
									/>
								</Form.Item>
								<Form.Item
									label="Rack Location Code"
									labelCol={{ style: { width: '150px', textAlign: "left" } }}
									wrapperCol={{ style: { width: '290px' } }}
									name="location_code"
									style={{
										marginBottom: "5px",
									}}
								>
									<Select
										showSearch
										allowClear
										placeholder="Select Location Code"
										optionFilterProp="label"
										onChange={onChange}
										options={locationCodeOptions}
										style={{ width: "100%" }}
										getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
									/>
								</Form.Item>
							</div>
						</div>
					</div>
				</div>
			</Form>
			<div className="gjs-grid-row" id="itkyp">
				<div className="gjs-grid-column" id="i7mpk">
					<div style={{ marginBottom: '16px', paddingTop: "30px" }}>
						<Button
							type="primary"
							loading={loading}
							icon={<SearchOutlined />}
							onClick={() => handleButtonClick(form.getFieldsValue())}
						>
							{loading ? 'Loading' : 'Search'}
						</Button>
					</div>
					<Table<DataType>
						rowSelection={rowSelection}
						columns={columns}
						dataSource={searchResults}
						scroll={{ x: 100 }}
						rowKey="key"
						className="table-gr"
						loading={loading}
						pagination={{
							current: pagination.current,
							pageSize: pagination.pageSize,
							total: pagination.total,
							showSizeChanger: true,
						}}
						onChange={handleTableChange}
						expandable={{
							rowExpandable: (record) => record.children !== undefined && record.children.length > 0,
						}}
						onRow={(record) => {
							return {
								onDoubleClick: () => {
									handleRowDoubleClick(record);
								},
							};
						}}
					/>
				</div>
			</div>
		</div>
	);
};

export default withInquiryItemsLogic(InquiryItemsUI);